module.exports = __webpack_public_path__ + "img/Group-1457.5c47696f.png";